// Omnix/client/ui/BrandingKitSelector.js
import { ComponentBase } from "../core/ComponentBase.js";

export class BrandingKitSelector extends ComponentBase {
    constructor(config) {
        super(config);
        this.options = [];
        this.selectedValue = null;
    }

    async initialize() {
        await super.initialize();
        await this.loadOptions();
    }

    async loadOptions() {
        try {
            const result = await this.appClient.rpcClient.call('BrandingKitRpc.getData', { pageSize: 1000 });
            this.options = (result.data || []).map(kit => ({
                value: kit._id,
                label: `${kit.name} ${kit.isDefault ? '(Default)' : ''}`
            }));
            if (this.selectElement) this.renderOptions();
        } catch (error) {
            this.log.error("Failed to load branding kits for selector:", error);
        }
    }

    render() {
        if (!this.container) {
            this.container = document.createElement('div');
            this.selectElement = document.createElement('select');
            this.selectElement.className = 'form-select';
            this.selectElement.addEventListener('change', () => {
                this.container.dispatchEvent(new Event('change', { bubbles: true }));
            });
            this.container.appendChild(this.selectElement);
        }
        this.renderOptions();
        return this.container;
    }

    renderOptions() {
        this.selectElement.innerHTML = `<option value="">-- Use Default Kit --</option>`;
        this.options.forEach(opt => {
            const optionEl = document.createElement('option');
            optionEl.value = opt.value;
            optionEl.textContent = opt.label;
            this.selectElement.appendChild(optionEl);
        });
        if (this.selectedValue) {
            this.selectElement.value = this.selectedValue;
        }
    }

    getValue() {
        return this.selectElement.value || null; // Return null if "Use Default" is selected
    }

    setValue(value) {
        this.selectedValue = value;
        if (this.selectElement) {
            this.selectElement.value = value || '';
        }
    }
}